import { useQuery } from "@tanstack/react-query";
import { getEcommCustomerSegmentation } from "../services/ecommCustomerSegmentationService";

export const useEcommCustomerSegmentation = () => {
  return useQuery({
    queryKey: ["ecomm-customer_segmentation"],
    queryFn: getEcommCustomerSegmentation,
    staleTime: 1000 * 60 * 5,
  });
};
